import { Sparkles, Gift, CheckCircle2, Search } from 'lucide-react';
import { SectionPageEditor } from '@/components/admin/SectionPageEditor';
import type { SectionDef } from '@/components/admin/SectionPageEditor';

// pages/partner-apply/page.tsx is mostly the application FORM itself
// (business details, document uploads, validation) — deliberately
// excluded here, same rationale as Login/Checkout: those labels are
// structural, tied 1:1 to real <input>/<select> fields and the DB
// submission mapping, not marketing content. Only the 3 genuinely
// editable sections are below: Hero, the Benefits sidebar, and the
// Success page shown after submitting. The dark "Contact" sidebar box
// reuses shared contact.info.title/faq.contactUs keys — skipped here
// since editing them would also change the Contact/FAQ pages.
// partnerApply.form.chooseFile is orphaned (unused leftover) and
// excluded along with the rest of the form.* namespace.
const PARTNER_APPLY_SECTIONS: SectionDef[] = [
  {
    key: 'hero',
    title: 'Hero',
    icon: Sparkles,
    texts: [
      { key: 'partnerApply.hero.label', label: 'Eyebrow Label' },
      { key: 'partnerApply.hero.heading', label: 'Heading' },
      { key: 'partnerApply.hero.subtitle', label: 'Subtitle' },
    ],
  },
  {
    key: 'benefits',
    title: 'Benefits Sidebar',
    icon: Gift,
    note: 'The application form itself (fields, uploads, validation) isn\'t editable here — same as Login/Checkout elsewhere.',
    texts: [
      { key: 'partnerApply.benefits.title', label: 'Title' },
      { key: 'partnerApply.benefits.brandSupport', label: 'Benefit — Brand Support' },
      { key: 'partnerApply.benefits.training', label: 'Benefit — Training' },
      { key: 'partnerApply.benefits.exclusive', label: 'Benefit — Exclusive' },
      { key: 'partnerApply.benefits.margin', label: 'Benefit — Margin' },
    ],
  },
  {
    key: 'success',
    title: 'Success Page',
    icon: CheckCircle2,
    texts: [
      { key: 'partnerApply.success.title', label: 'Heading' },
      { key: 'partnerApply.success.body', label: 'Body Text', long: true },
      { key: 'partnerApply.success.back', label: 'Back Button' },
    ],
  },
  {
    key: 'seo',
    title: 'SEO',
    icon: Search,
    note: 'Shown in Google search results and social media link previews — not visible on the page itself.',
    texts: [
      { key: 'seo.partnerApply.title', label: 'Meta Title', long: true },
      { key: 'seo.partnerApply.description', label: 'Meta Description', long: true },
    ],
  },
];

export default function AdminPartnerApplyPage() {
  return <SectionPageEditor pageKey="partnerApply" title="Partner Apply" sections={PARTNER_APPLY_SECTIONS} />;
}
